import React, { createContext, useContext, useMemo } from 'react';

import { Configuration, DetectionsApi } from '@rtkwlf/detection-service';

import { useAuthContext } from '@packages/legacy/auth';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

const detectionGlobalProdURL =
  'https://detection-service.managedgw.global-prod.arcticwolf.net';

const detectionGlobalTestURL =
  'https://detection-service.detection-service.test.global-test.rtkwlf.io';

const ApiContext = createContext<DetectionsApi | null>(null);

export const useDetectionServiceApi = (): DetectionsApi => {
  const ctx = useContext(ApiContext);
  if (ctx === null) {
    throw new Error(
      'useDetectionServiceApi hook must be used within an DetectionServiceApiProvider; ensure your node is wrapped in one.',
    );
  } else {
    return ctx;
  }
};

export const DetectionServiceApiProvider = ({
  children,
}: React.PropsWithChildren) => {
  const { fetchApi } = useAuthContext();

  const [detectionCatalogTestEnvFF] = useFeatureFlag(
    'DETECTION_CATALOG_TEST_ENV_REQUIRES_VPN',
  );

  const api = useMemo(
    () =>
      new DetectionsApi(
        new Configuration({
          basePath: detectionCatalogTestEnvFF
            ? detectionGlobalTestURL
            : detectionGlobalProdURL,
          fetchApi,
        }),
      ),
    [detectionCatalogTestEnvFF, fetchApi],
  );

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};
